import axios from "axios";
import { useParams ,useLocation} from "react-router-dom";


// Test and Live API URLs from .env
const TEST_BASE = process.env.REACT_APP_API_TEST_URL;
const LIVE_BASE = process.env.REACT_APP_API_LIVE_URL;

const REST_API_BASE_URL = TEST_BASE;
const USER_LOGIN_URL = `${LIVE_BASE}/login`;
const SURVEY_LEAD_SAVE_URL = `${LIVE_BASE}/leads`;
const SURVEY_LEAD_SAVE_LEAD = "https://localhost:8080/saveLead"; // Not covered by env
const SURVEY_REGISTER_SAVE_LEAD = `${LIVE_BASE}/register`;
const MASTER_SOURCE = `${LIVE_BASE}/leads/master-source`;
const VIEW_CALL_BACK = `${LIVE_BASE}/leads`;
const VIEW_CALL_BACK_TEST = `${TEST_BASE}/leads`;
const GET_ALL_USERS = `${LIVE_BASE}/users`;
const GET_SALES_USERS = `${LIVE_BASE}/users`;
const POST_DISTRIBUTE_LEADS = `${LIVE_BASE}/leads/distribute`;
const CHANGE_PASSWORD = `${LIVE_BASE}/admin/users/37/change-password`;
const CHECK_MPR = `${LIVE_BASE}/check/mpr-number/`;
const CHECK_SUPPLY_NUMBER = `${LIVE_BASE}/check/supply-number/`;

export const storeToken = (token) => localStorage.setItem("token",token);

export const getToken = ()  => localStorage.getItem("token");

axios.interceptors.request.use(function (config){

  config.headers['Authorization'] = getToken();
  return config;
}, function(error){
    return Promise.reject(error);
});


export const masterSource = async () => {
  try {
    const response = await axios.get(MASTER_SOURCE);
    console.log("masterSource")
    return response; // or response.data if you need the data only
  } catch (error) {
    console.error("Error fetching master source:", error);
    throw error; // Re-throw the error to handle it later if needed
  }
};
const paramValue = 'sales';
export const getAllUsers = () => axios.get(GET_ALL_USERS);
export const getSalesUsers = () => axios.get(GET_SALES_USERS,{params: {
  role: paramValue
}});

export const  createUserDetail = (userDetails) => axios.post(REST_API_BASE_URL,userDetails);
export const  registerUserDetail =  (user) => axios.post(REST_API_BASE_URL,user);
export const loginUserId = (requestBody) => axios.post(USER_LOGIN_URL, requestBody);
export const surveyLeadSave = (requestBody) => axios.post(SURVEY_LEAD_SAVE_URL, requestBody);
export const distributeLeads = (requestBodyDistribute) => axios.post(POST_DISTRIBUTE_LEADS, requestBodyDistribute);

export const adminChangePassword = (requestBody) => axios.post(CHANGE_PASSWORD, requestBody);

export const viewCallBackAdmin = (page = 1, perPage = 10) => 
  axios.get(VIEW_CALL_BACK, {
    params: {
      page: page,
      per_page: perPage
    }
  });
 

export const viewAdminDistributed = () => axios.get(VIEW_CALL_BACK,{ params: {
  exclude_distributed: true
}});

export const viewSalesNewLeadDetails = () => axios.get(VIEW_CALL_BACK,{ params: {
  new_leads_only: true
}});

export const viewSalesReValidatedDetails = () => axios.get(VIEW_CALL_BACK,{ params: {
  revalidated_renewals_only: true
}});

export const viewSalesDetailsBasedOnStatus = (salesStatus) => axios.get(VIEW_CALL_BACK,{
  params: {
    sales_status: salesStatus
  }});

  export const viewSearchQuery = (query, exclude_distributed = null) =>
  axios.get(VIEW_CALL_BACK, {
    params: {
      filters: query,
      ...(exclude_distributed !== null && { exclude_distributed })
    }
  });

    export const viewLeadSearchQuery = (query) => axios.get(VIEW_CALL_BACK,{
      params: {
        filters: query
      }});

  export const viewSalesAllDetails = () => axios.get(VIEW_CALL_BACK);
  

  export const viewQualitySurvey = () => axios.get(VIEW_CALL_BACK,{
    params: {
      lead_status: 3
    }});
  
    
export const viewPlainSurvey = () => axios.get(VIEW_CALL_BACK,{params: { lead_status: 2  }});
export const viewQualityLowEAC = () => axios.get(VIEW_CALL_BACK,{params: { lead_status: 4  }});
export const viewCallBack = () => axios.get(VIEW_CALL_BACK,{ params: {lead_status: 1}});
export const viewSurveyValidated = () => axios.get(VIEW_CALL_BACK,{ params: {lead_status: 5}});
export const viewSurveyValidatedLowEac = () => axios.get(VIEW_CALL_BACK,{ params: {lead_status: 6}});
export const viewSurveySearch = () => axios.get(VIEW_CALL_BACK);


export const checkMPR = (mprNumber) => {
  // Construct the full URL with the mprNumber
  const url = `${CHECK_MPR}${mprNumber}`;

  // Perform the GET request
  return axios.get(url);
};

export const clickId = (id) => {
  // Construct the full URL with the mprNumber
  const url = `${VIEW_CALL_BACK}${'/'+id}`;

  // Perform the GET request
  return axios.get(url);
};

export const checkSupplyNumber = (supplyNumber) => {
  // Construct the full URL with the mprNumber
  const url = `${CHECK_SUPPLY_NUMBER}${supplyNumber}`;

  // Perform the GET request
  return axios.get(url);
};



export const viewQualityReject = () => axios.get(VIEW_CALL_BACK,{params: {lead_status: 8 }})
.catch(error => console.log(error));
export const viewQualityHold   = () => axios.get(VIEW_CALL_BACK,{params: {lead_status: 7}});


export const surveyRegisterSaveTest = (requestBodySave) => axios.post(SURVEY_REGISTER_SAVE_LEAD, requestBodySave);

export async function surveyRegisterSave(requestBodySave) {
    return fetch(SURVEY_REGISTER_SAVE_LEAD, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body:(requestBodySave)
    })
      .then(data => console.log(data.json()))
      .catch(error => console.log(error))
   }

  //  export async function distributeLeads(requestBodyDistribute) {
  //   return fetch(POST_DISTRIBUTE_LEADS, {
  //     method: 'POST',
  //     headers: {
  //       'Content-Type': 'application/json'
  //     },
  //     body:(requestBodyDistribute)
  //   })
  //     .then(data => console.log(data.json()))
  //     .catch(error => console.log(error))
  //  }
export async function surveyLeadSaveTest(requestBodySave) {
    return fetch(SURVEY_LEAD_SAVE_URL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body:(requestBodySave)
    })
      .then(data => data.json())
   }
export async function loginUser(credentials) {
    return fetch(USER_LOGIN_URL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(credentials)
    })
      .then(data => data.json())
   }




